import React from 'react'
import { graphql } from 'gatsby'
import { BlogNav, PostGrid, Section, BlogCtaBanner, SEO } from 'newComponents'
import Layout from '../components/layout.js'
import './tag.scss'

const BlogTag = ({ data, location, pageContext }) => {
  const paginationAmount = 12

  const { tagPosts } = data
  const { nodes: posts = [] } = tagPosts

  const { name } = pageContext

  // seo data
  const seo = {
    title: name,
    description: `View LaunchDarkly blog posts tagged with ${name}`
  }

  return (
    <Layout seo={seo}>
      <SEO {...seo} />
      <div className="tag">
        <BlogNav />
        <Section className="tag-posts-container">
          <PostGrid
            posts={posts}
            title={`All ${name} posts`}
            className="grid-variant"
            paginationAmount={paginationAmount}
          />
        </Section>
        {/* <BlogCtaBanner /> */}
      </div>
    </Layout>
  )
}

export default BlogTag

export const tagQuery = graphql`
  query PostsByTag($name: [String]) {
    tagPosts: allPrismicBlogPost(filter: { tags: { in: $name } }, sort: { order: DESC, fields: data___timestamp }) {
      nodes {
        uid
        id
        data {
          author {
            uid
            document {
              ... on PrismicAuthor {
                uid
                id
                data {
                  author_image {
                    url
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 150, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  author_name {
                    html
                    text
                  }
                }
              }
            }
          }
          featured_image {
            url
          }
          categories {
            category {
              uid
              id
            }
          }
          hide_date
          timestamp(formatString: "MMMM D, YYYY")
          title {
            html
            text
          }
        }
      }
    }
  }
`
